import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

import {
  formatDate,
  formatMoney,
  getShortString,
} from '../../../../../../../../lib/functions/utils';

export const exportBoletinesLabels: any = {
  boled: {
    label: 'Boletín Digital',
    dataHeaders: [
      { key: 'expirationDate', label: 'Fec. Ven.', type: 'date' },
      { key: 'documentType', label: 'Tip. Doc' },
      { key: 'moneyCode', label: 'Moneda' },
      { key: 'unpaidAmount', label: 'Monto', type: 'money' },
      { key: 'justificationDescription', label: 'Motivo' },
      { key: 'libradorName', label: 'Librador' },
      { key: 'equifaxRegisterDate', label: 'Fecha Ingreso', type: 'date' },
      { key: 'debtType', label: 'Tipo Deuda' },
      { key: 'marketDescription', label: 'Mercado' },
    ],
  },
  bolab: {
    label: 'Boletín Laboral',
    dataHeaders: [
      { key: 'institutionName', label: 'Librador' },
      { key: 'delinquencyAmount', label: 'Monto' },
      { key: 'injuryType', label: 'Tipo Infracción' },
      { key: 'infractionNumber', label: 'Infracción' },
      { key: 'boletinNumber', label: 'N° Boletín' },
      { key: 'boletinPage', label: 'Pag. Boletín' },
    ],
  },
  bolcom: {
    label: 'Boletín Comercial',
    dataHeaders: [
      { key: 'expirationDate', label: 'Fec. Ven.', type: 'date' },
      { key: 'documentType', label: 'Tip. Doc' },
      { key: 'moneyCode', label: 'Moneda' },
      { key: 'unpaidAmount', label: 'Monto', type: 'money' },
      { key: 'justificationDescription', label: 'Motivo' },
      { key: 'libradorName', label: 'Librador' },
      { key: 'registerDate', label: 'Fecha Ingreso', type: 'date' },
      { key: 'debtType', label: 'Tipo Deuda' },
      { key: 'marketDescription', label: 'Mercado' },
    ],
  },
  icom: {
    label: 'Informe Complementario de Morosidades',
    dataHeaders: [
      { key: 'expirationDate', label: 'Fec. Ven.', type: 'date' },
      { key: 'documentType', label: 'Tip. Doc' },
      { key: 'chequeOperatioNumber', label: 'N° Doc.' },
      { key: 'moneyCode', label: 'Moneda' },
      { key: 'unpaidAmount', label: 'Monto', type: 'money' },
      { key: 'registerDate', label: 'Fecha Ingreso', type: 'date' },
    ],
  },
};

export const generateCompanyReportPDF = (
  response: any,
  lastUpdate?: Date,
  imgData?: string | null,
) => {
  const doc = new jsPDF();
  const data = response.data;
  const debt = data.summary?.debt || {};
  const extractDate = formatDate(new Date(), 'large');
  const lastUpdateDate = lastUpdate
    ? formatDate(lastUpdate, 'large')
    : extractDate;

  let y = 10;
  doc.setFontSize(8);
  doc.text(`Fecha de extracción: ${extractDate}`, 146, y);
  y += 5;
  doc.text(`Fecha de actualización: ${lastUpdateDate}`, 143, y);

  y = 15;
  doc.setFontSize(14);
  doc.text('Reporte Empresa', 14, y);
  y += 10;

  doc.text('Antecedentes Empresa y Financieros', 14, y);
  doc.setDrawColor('#0F23DF');
  doc.setLineWidth(0.4);
  doc.line(14, y + 1, 190, y + 1);
  y += 10;

  doc.setFontSize(10);
  doc.text(
    `Razón Social: ${getShortString(data.companySummary.businessName, 34)}`,
    14,
    y,
  );
  doc.text(`RUT: ${response.identifier}`, 120, y);
  y += 6;
  doc.text(`Fecha Inicio: ${formatDate(data.companySummary.startDate)}`, 14, y);
  doc.text(`Tamaño: ${data.companySummary.companySize}`, 120, y);
  y += 6;
  doc.text(`Colaboradores: ${data.companySummary.collaborators}`, 14, y);
  doc.text(
    `Everclean: ${data.companySummary.everclean === '1' ? 'Sí' : 'No'}`,
    120,
    y,
  );
  y += 10;

  doc.setFontSize(12);
  doc.text('Resumen de Deudas y Protestos', 14, y);
  doc.setFontSize(10);
  y += 6;
  doc.text(`Protestos: ${debt?.protests?.documentCount || 0}`, 14, y);
  doc.text(
    `Multas/Infracciones: ${debt?.totalMultaeInfraccionLaboralPrevisional || 0}`,
    120,
    y,
  );
  y += 6;
  doc.text(
    `Acceso Cámara Comercio: ${debt?.accessCamaraComercio || 'NO'}`,
    14,
    y,
  );
  const boletinesMontoTotal =
    Number(debt?.bolab?.amount || 0) +
    Number(debt?.bolcom?.amount || 0) +
    Number(debt?.boled?.amount || 0) +
    Number(debt?.icom?.amount || 0);
  const boletinesDocsTotal =
    (debt?.bolab?.documentCount || 0) +
    (debt?.bolcom?.documentCount || 0) +
    (debt?.boled?.documentCount || 0) +
    (debt?.icom?.documentCount || 0);
  doc.text(
    `Boletines: ${formatMoney(boletinesMontoTotal)} (${boletinesDocsTotal})`,
    120,
    y,
  );
  y += 10;

  doc.setFontSize(12);
  doc.text('Bienes', 14, y);
  doc.setFontSize(10);
  y += 6;
  doc.text(
    `Propiedades: ${data.tributarySummary?.realState?.propertiesCount || 0}`,
    14,
    y,
  );
  doc.text(
    `Valor Propiedades: ${formatMoney(
      Number(data.tributarySummary?.realState?.totalAssesmentAmountPesos || 0),
    )}`,
    120,
    y,
  );
  y += 6;
  doc.text(`Vehículos: ${data.summary?.vehiclesNumber || 0}`, 14, y);
  doc.text(
    `Valor Vehículos: ${formatMoney(data.summary?.vehiclesValuatio)}`,
    120,
    y,
  );
  y += 10;

  doc.text(
    'Score de Riesgo: ' + (data.summary?.riskScore?.score || 'N/A'),
    14,
    y,
  );
  y += 6;
  doc.text(
    'Acreditaciones: ' + (data.summary?.accreditationsFlag || 'NO'),
    14,
    y,
  );
  y += 10;

  if (imgData) {
    doc.setFontSize(12);
    doc.text('Score Histórico', 14, y);
    doc.setFontSize(10);
    y += 6;
    doc.addImage(imgData, 'PNG', 10, y, 180, 45);
    y += 45;
  }

  // ------------------ TABLAS ------------------

  const renderTable = (
    title: string,
    data: any[],
    headers: { key: string; label: string; type?: string }[],
  ) => {
    y += 10;
    doc.setFontSize(12);
    doc.text(title, 14, y);
    y += 2;
    autoTable(doc, {
      startY: y,
      head: [headers.map((h) => h.label)],
      body:
        data && data.length > 0
          ? data.map((item) => headers.map((h) => format(item[h.key], h.type)))
          : [],
      styles: { fontSize: 8 },
      headStyles: {
        fillColor: [230, 230, 230],
        textColor: [0, 0, 0], // negro
      },
      margin: { left: 14, right: 14 },
    });
    y = (doc as any).lastAutoTable.finalY;
  };

  const format = (value: any, type?: string) => {
    if (!type) return value;
    if (type === 'date') return formatDate(value);
    if (type === 'money') return formatMoney(value);
    return value;
  };

  renderTable('Actividades', data.companySummary.activities, [
    { key: 'activityCode', label: 'Actividad' },
    { key: 'description', label: 'Tipo de Actividad' },
  ]);

  renderTable('Socios', data.companySummary.relatedPartners, [
    { key: 'namePartner', label: 'Nombre' },
    { key: 'rutPartner', label: 'RUT' },
    { key: 'partnershipCount', label: 'Participaciones' },
  ]);

  renderTable('Sociedades', data.companySummary.mainPartners, [
    { key: 'businessName', label: 'Razón Social' },
    { key: 'rutOfTheCompany', label: 'RUT' },
    { key: 'partnerCount', label: 'Cantidad de Socios' },
  ]);

  y += 10;
  doc.setFontSize(14);
  doc.text('Antecedentes Burós', 14, y);
  doc.setDrawColor('#0F23DF');
  doc.setLineWidth(0.4);
  doc.line(14, y + 1, 190, y + 1);

  Object.keys(exportBoletinesLabels).forEach((key) => {
    const boletin = debt[key];
    const config = exportBoletinesLabels[key];
    if (boletin?.documentCount > 0 && Array.isArray(boletin.documents)) {
      renderTable(config.label, boletin.documents, config.dataHeaders);
    }
  });

  renderTable(
    'Consultas de Terceros',
    data.companySummary.consultsByOthers.slice(0, 15),
    [
      { key: 'businessName', label: 'Empresa Consultante' },
      { key: 'date', label: 'Fecha', type: 'date' },
      { key: 'report', label: 'Tipo de Reporte' },
    ],
  );

  doc.save(`ReporteEmpresa-${response.identifier}.pdf`);
};
